import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const FormActions = ({ children }) => <S.FormActions>{children}</S.FormActions>

export default FormActions
